
export const APP_FILE_EQUIPMENT_LIST= "/equipment-list";
export const APP_FILE_MANAGE_EQUIPMENT= "/equipment/manage-equipment";